<template>
  <div class="logo">
    <a href="/w/">
      <picture class="logo-img">
        <source srcset="@/assets/img/logo.webp" type="image/webp" />
        <img class="logo-img" src="@/assets/img/logos.png" alt="Sovtes Logo" />
      </picture>
    </a>
  </div>
</template>

<script>
export default {
  name: 'VLogo',
}
</script>

<style lang="scss" scoped>
.logo {
  /* min-width: 200px; */
  text-align: center;
  padding: 10px;
  &-img {
    height: 100px;
  }
}
@media (max-width: 984px) {
  .logo {
    padding: 0;
    &-img {
      height: 80px;
    }
  }
}

@media (max-width: 414px) {
  .logo {
    padding: 0;
    padding-left: 10px;
    /* min-width: 140px; */
    &-img {
      height: 64px;
    }
  }
}
@media (max-width: 375px) {
  .logo {
    padding: 0;
    padding-left: 10px;
    /* min-width: 140px; */
    &-img {
      height: 52px;
    }
  }
}
</style>
